import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e957f69"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "board-page" }
const _hoisted_2 = { class: "ws_common_operation" }
const _hoisted_3 = { class: "board-list" }

import { ref, onMounted } from 'vue'
import ComponentForm from './components/component-form-drawer.vue'
import BMap from './components/b-map.vue'
import BLive from './components/b-live.vue'
import BChart from './components/b-chart.vue'
import BText from './components/b-text.vue'
import BTextS from './components/b-text-s.vue'
import BWater from './components/b-water.vue'
import BWaterS from './components/b-water-s.vue'
import { msgbox } from '@/utils'
import { ElMessage } from 'element-plus'
import { queryBoardList, deleteBoardInfo } from '@/api'
import { CODE_ENUM, BOARD_TYPE } from '@/common'
import i18n from '@/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const t = i18n.global.t

const getComponentType = (data: any) => {
  const { type, dataConfig } = data
  if (type === BOARD_TYPE.LOCATION) {
    return BMap
  } else if (type === BOARD_TYPE.TEXT) {
    const list = JSON.parse(dataConfig)
    return list.length === 1 ? BText : BTextS
  } else if (type === BOARD_TYPE.VIDEO) {
    return BLive
  } else if (type === BOARD_TYPE.STATISTICS) {
    return BChart
  } else if (type === BOARD_TYPE.INSTRUMENT) {
    const list = JSON.parse(dataConfig)
    return list.length === 1 ? BWater : BWaterS
  }
}

const list = ref([])
const fetchList = async () => {
  const res: any = await queryBoardList()
  if (res?.code === CODE_ENUM.SUCCESS) {
    list.value = res.data || []
  }
}

onMounted(async () => {
  fetchList()
})

const formConf = ref({
  visible: false,
  data: {},
})

const toForm = (data = {}) => {
  formConf.value = {
    visible: true,
    data,
  }
}

const onEdit = (data: any) => {
  toForm(data)
}

const onDelete = (row: any) => {
  msgbox({
    tip: t('STATISTICS.bdelTip'),
    thenFn: () => handleDelete(row),
  })
}

const handleDelete = async ({ id }: any) => {
  const res: any = await deleteBoardInfo({ id })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(res?.msg)
    fetchList()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (toForm())),
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('STATISTICS.bnew')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
          return (_openBlock(), _createBlock(_resolveDynamicComponent(getComponentType(item)), _mergeProps({
            key: item.id + item.updateDate
          }, { ...item }, {
            onOnEdit: ($event: any) => (onEdit(item)),
            onOnDelete: ($event: any) => (onDelete(item))
          }), null, 16, ["onOnEdit", "onOnDelete"]))
        }), 128))
      ])
    ]),
    _createVNode(ComponentForm, {
      visible: formConf.value.visible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((formConf.value.visible) = $event)),
      data: formConf.value.data,
      onSuccess: fetchList
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})